/* Core Energy header: announcement rotation, mega menu, dropdowns, search, mobile drawer, cart count. */
(function () {
  if (window.__ceHeader) return;
  window.__ceHeader = true;

  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(root) {
    var hdr = (root || document).querySelector('[data-ce-header]');
    if (!hdr || hdr.__ce) return;
    hdr.__ce = true;

    /* Announcement rotation */
    var ann = hdr.querySelector('[data-ce-ann]');
    if (ann) {
      var msgs = ann.querySelectorAll('.ce-ann__msg');
      var idx = 0;
      var interval = parseInt(ann.getAttribute('data-interval'), 10) || 5000;
      if (msgs.length > 1) {
        setInterval(function () {
          if (ann.classList.contains('ce-ann--row') && window.innerWidth >= 990) return;
          msgs[idx].classList.remove('is-active');
          idx = (idx + 1) % msgs.length;
          msgs[idx].classList.add('is-active');
        }, interval);
      }
    }

    /* Mega + dropdowns */
    var items = hdr.querySelectorAll('[data-ce-mega], [data-ce-drop]');
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var a = it.querySelector('.ce-nav__link');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    function open(it) {
      closeAll(it);
      it.classList.add('is-open');
      var a = it.querySelector('.ce-nav__link');
      if (a) a.setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (it) {
      var timer;
      var link = it.querySelector('.ce-nav__link');
      it.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { open(it); }, 80);
      });
      it.addEventListener('mouseleave', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { it.classList.remove('is-open'); if (link) link.setAttribute('aria-expanded', 'false'); }, 160);
      });
      if (link) link.addEventListener('click', function (e) {
        // Touch / keyboard: first tap opens, second tap follows the link.
        if (!it.classList.contains('is-open')) { e.preventDefault(); open(it); }
      });
      it.addEventListener('focusout', function (e) {
        if (!it.contains(e.relatedTarget)) it.classList.remove('is-open');
      });
    });
    document.addEventListener('click', function (e) { if (!hdr.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeMnav(); closeSearch(); }
    });

    /* Search */
    var search = hdr.querySelector('[data-ce-search]');
    var searchBtn = hdr.querySelector('[data-ce-search-toggle]');
    function closeSearch() { if (search) { search.classList.remove('is-open'); if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false'); } }
    if (search && searchBtn) {
      searchBtn.addEventListener('click', function () {
        var isOpen = search.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) { var input = search.querySelector('input[type="search"]'); if (input) input.focus(); }
      });
    }

    /* Mobile drawer */
    var mnav = hdr.querySelector('[data-ce-mnav]');
    var burger = hdr.querySelector('[data-ce-mnav-open]');
    function openMnav() {
      if (!mnav) return;
      mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ce-lock');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var c = mnav.querySelector('[data-ce-mnav-close].ce-hdr__icon'); if (c) c.focus();
    }
    function closeMnav() {
      if (!mnav || !mnav.classList.contains('is-open')) return;
      mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ce-lock');
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    }
    if (burger) burger.addEventListener('click', openMnav);
    if (mnav) mnav.querySelectorAll('[data-ce-mnav-close]').forEach(function (b) { b.addEventListener('click', closeMnav); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) closeMnav(); });
  }

  /* Cart count sync (fired by the cart drawer) */
  document.addEventListener('ce:cart:updated', function (e) {
    var count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-ce-cart-count]').forEach(function (el) {
      var prev = parseInt(el.getAttribute('data-count'), 10) || 0;
      el.textContent = count; el.setAttribute('data-count', count);
      if (count > prev) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
